import { createContext } from 'react';
import type { SearchParams } from '@/server/searchParams.ts';

export type CardsContextType = {
  travellersCount: number;
  searchParams: SearchParams;
  isWaiting: boolean;
  isLoading: boolean;
  isWhiteLabel: boolean;
};

export const CardsContext = createContext({
  travellersCount: 0,
  searchParams: {},
  isWaiting: false,
  isLoading: false,
  isWhiteLabel: false,
} as CardsContextType);
